import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaUserCircle, FaArrowLeft, FaBars } from "react-icons/fa";
import { resellerPageTitles } from "./Util/ResellerPageTitles";

const ReSellerHeader = ({ setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

 
  const path = location.pathname;

  const matchedRoute = Object.keys(resellerPageTitles).find((route) =>
    path.startsWith(route.replace("/:id", "")),
  );

  const pageTitle = resellerPageTitles[matchedRoute] || "Reseller Panel";


  return (
    <header className="sticky top-0 z-30 bg-white border-b px-4 sm:px-6 py-7 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          onClick={() => setSidebarOpen(true)}
          className="md:hidden p-2 rounded-md hover:bg-gray-100"
        >
          <FaBars />
        </button>

        <button
          onClick={() => navigate(-1)}
          className="hidden sm:hidden p-2 rounded-md hover:bg-gray-100"
        >
          <FaArrowLeft />
        </button>

        <h1 className="text-lg sm:text-xl font-semibold text-gray-800">
          {pageTitle}
        </h1>
      </div>

      <NavLink
        to="/reseller/profile"
        className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-gray-100"
      >
        <FaUserCircle className="text-xl text-gray-800" />
        <span className="hidden sm:block text-sm font-bold text-gray-700">
          Profile
        </span>
      </NavLink>
    </header>
  );
};

export default ReSellerHeader;
